<div class="paragraph-group-layout" *ngIf="!loading">
  <p>{{ "MODAL_CONTENTS.SAVE_AND_CONTINUE.PARAGRAPH_1" | translate : {recipient: emailRecipient} }}</p>
  <p>{{ "MODAL_CONTENTS.SAVE_AND_CONTINUE.PARAGRAPH_2" | translate }}</p>
</div>
